import { render, staticRenderFns } from "./form-col.vue?vue&type=template&id=7bee208f&"
import script from "./form-col.vue?vue&type=script&lang=ts&"
export * from "./form-col.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports